import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Stack,
  Paper,
  Grid,
} from "@mui/material";
import BreadCrumb from "../../../comman/Breadcrumb";
import { useParams } from "react-router-dom";
import { apiRequest } from "../../../utils/config/apiRequest";
import { apiUrl } from "../../../utils/endPoints/apiUrl";
import ComplaintStatus from "../../../component/complaint/ComplaintStatus";
import ComplaintDetails from "../../../component/complaint/ComplaintDetails";
import ReplyBox from "../../../component/complaint/ReplyBox";
import { fDateUTC } from "../../../utils/helper/timeHelpers";

const ComplaintsDetails = () => {

  const { id } = useParams();

  const [load, setLoad] = useState(false);
  const [complaintInfo, setComplaintInfo] = useState({});
  const [complaintResponse , setComplaintResponse] = useState([])

  const fetchComplaint = async () => {
    setLoad(true);
    const { data, status } = await apiRequest({
      endUrl: apiUrl.complaints.complaintsDetailById(id),
    });
    setLoad(false);

    if (status) {
      setComplaintInfo(data); 
    }
  };


  const fetchResponse = async() =>{
    if (!id) return;
    setLoad(true);
    const {data, status} = await apiRequest({
      endUrl : apiUrl.complaints.responseDetail,
      query: { ticketId : id }
    });
    setLoad(false);
    if(status){
      setComplaintResponse(data)
    }
  }

  useEffect(() => {
    if (id) fetchComplaint();
    fetchResponse()
  }, [id]);

  return (
    <React.Fragment>

      <BreadCrumb
        isBack
        leftContent={
          <Box sx={{ mt: 1.5 }}>
            <Stack>
              <Typography variant="h5">Complaint Details</Typography>
            </Stack>
          </Box>
        }
        action={
          <Stack direction="row" gap={2} alignItems="center" sx={{ minWidth: 300, mt: 1.5  }} >
            <ComplaintStatus
              ticketId={complaintInfo?.ticket?._id}
              OnSelect={fetchComplaint}   
            />
          </Stack>
        }
      />

      <Grid container spacing={2} mb={2}>
        
        <Grid item md={8} xs={12}>
          <Paper elevation={1} sx={{ p: 2, mt: 3, borderRadius: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Conversation
            </Typography>

            <Box sx={{ maxHeight: 300, overflowY: "auto", mb: 2 }}>
              {complaintResponse?.responses?.length ? (
                complaintResponse?.responses.map((res, index) => (
                  <Box
                    key={index}
                    sx={{
                      mb: 1.5,
                      p: 1.5,
                      borderRadius: 1,
                      backgroundColor:
                        res.from === "ADMIN" ? "#f5f5f5" : "#e8f5e9",
                    }}
                  >
                    <Typography variant="caption" color="text.secondary">
                      {res.from && (
                        <>  
                          {res.from} • {fDateUTC(res.createdAt, null, "DD MMM YYYY")}
                        </>
                    )}
                    </Typography>

                    <Typography variant="body2">
                      {res.response}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No responses yet
                </Typography>
              )}
            </Box>

            <ReplyBox
              ticketId={complaintInfo?.ticket?._id}
              onSuccess={fetchComplaint}
            />
          </Paper>
        </Grid>

        {/* RIGHT: Complaint Details */}
       <Grid item md={4} xs={12}>
        <Box sx={{ mt: 3 }}>
          <ComplaintDetails complaintInfo={complaintInfo} />
        </Box>
      </Grid>


      </Grid>

    </React.Fragment>
  );
};

export default ComplaintsDetails;
